import cx from 'classnames';

import AlertTriangle from 'components/Icons/AlertTriangle.svg';

import s from './FieldErrorMessage.module.css';

export const FieldErrorMessage = ({
  id,
  error,
  errorClassName,
}: {
  id: string;
  error?: string;
  errorClassName?: string;
}) => {
  return (
    <div
      role="alert"
      className={cx(errorClassName, s.errorContainer, {
        [s.hasError]: !!error,
      })}
      aria-describedby={`error-${id}`}
    >
      <div className={s.errorInnerContainer}>
        <AlertTriangle />
        <span className={s.errorMessage} id={`error-${id}`}>
          {error}
        </span>
      </div>
    </div>
  );
};
